import { DynamicObjectInterface } from '../../sdk/type';

export const HasSpecialCharacters = (input: string) => {
  const specialCharsRegex = /[!#$%^&*(),;'"/?{}|<>[\]`~]/;
  return specialCharsRegex.test(input);
};

export const validateNoSpecialCharacter = (input: string) => {
  const regex = /^[a-zA-Z0-9\s]+$/;
  return regex.test(input);
};

export const validateAttachment = (e: DynamicObjectInterface, t: Function, fileSizeLimit: number) => {
  const VALID_FILE_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/svg+xml',
    'image/png',
    'image/tiff',
    'image/gif',
    'application/pdf',
  ];
  const MAX_FILE_SIZE = fileSizeLimit * 1024 * 1024; // 20MB

  if (
    e?.target &&
    ((e?.target?.files && e?.target?.files?.length > 0) ||
      (e?.dataTransfer?.files && e?.dataTransfer?.files?.length > 0))
  ) {
    const file = e.target.files || e.dataTransfer.files;
    const isFileSizeValid = file[0].size <= MAX_FILE_SIZE; // Valid File Size
    const isFileTypeValid = VALID_FILE_TYPES.includes(file[0].type); // Valid File Type

    let message = '';
    if (!isFileSizeValid && !isFileTypeValid) {
      message = t('dashboard.api-message.common.invalidFileAndExceedLimit');
    } else if (!isFileSizeValid && isFileTypeValid) {
      message = t('dashboard.api-message.common.fileExceedsLimit');
    } else if (isFileSizeValid && !isFileTypeValid) {
      message = t('dashboard.api-message.common.invalidFileType');
    }
    const isFileValid = isFileSizeValid && isFileTypeValid;

    return { status: isFileValid, message };
  }
};
